Jelly.Interface.Randomize = function(Parameters) {	
	// Randomize displayed items
	// List_Element
	// Fisher–Yates shuffle 
	var List = $(Parameters["List_Element"]).children();
	var Remaining = List.length;
	var One, Two;
	while (Remaining) {
		One = Math.floor(Math.random() * Remaining--);
		Two = List[One];
		List[Remaining] = List[One];
		List[One] = Two;
	}
	List.detach().appendTo(Parameters["List_Element"]);
};
